/* eslint semi:0 */
import userActions from 'actions/userToolbarActions'
import { warn } from 'application/console'
import utilsScript from 'utils/script'
import { mithrilHelpers } from 'utils/mithril'

const FB_CONNECT_URL = '/auth/facebook/callback'
let facebook = utilsScript.external.load({ name: 'facebook' })

let facebookAuthenticationProvider = {  //eslint-disable-line no-unused-vars

  login() {
    facebook(() => window.FB.login(this.handleLoginResponse.part(userActions.authenticated), { scope: 'public_profile,email' }))
  },

  handleLoginResponse(successCallback, response) {
    if (response.status === 'connected' && response.authResponse) {
      mithrilHelpers.safeRequest({
        method: 'GET',
        url: FB_CONNECT_URL,
        data: { signed_request: response.authResponse.signedRequest }  //eslint-disable-line camelcase
      }).then(
        successCallback,
        userActions.autnenticationFailed
      )
    }
    else {
      userActions.autnenticationFailed(response)  //TODO: probably should be an independent action
    }
  },

  reAuthenticate() {
    facebook(() => window.FB.getLoginStatus(this.handleLoginResponse.part(userActions.reauthenticated)))
  }

}

export { facebookAuthenticationProvider }


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/facebook/facebookAuthenticationProvider.js